export default __webpack_public_path__ + "static/media/eggopenedback.dfec54d7.png";